import React, { ChangeEvent } from "react";
import { useFormContext, Controller, FieldValues } from "react-hook-form";
import { Form } from "react-bootstrap";

interface CustomFormControlProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size" | "value"> {
  placeholder: string;
  name: string;
  required?: boolean;
  onInputChange?: () => void;
}


const ControlledInput = ({ placeholder, name, required, onInputChange, ...props }: CustomFormControlProps) => { // just ambar: verify
  const { control } = useFormContext<FieldValues>();
  return (
    <Controller
      render={({ field }) => (
        <Form.Control
          type="text"
          placeholder={placeholder}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            field.onChange(e.target.value);
            if(onInputChange)onInputChange();
          }}
          {...props}
        />
      )}
      rules={required && ({ required }) || {}}
      control={control || {}}
      name={name}
      defaultValue={props.defaultValue}
    />
  );
};

export default ControlledInput;
